<template>
  <div
    tabindex="0"
    class="dropdown"
    :class="bodyClass"
    @keydown.up.prevent="activate"
    @keydown.down.prevent="activate"
    @keydown.enter.prevent="deactivate"
    @blur.prevent="deactivate"
    @keyup.esc.prevent="deactivate"
  >
    <div
      class="dropdown-toggle d-flex align-items-center"
      @mousedown.prevent="toggle"
    >
      {{ value.ordering.name }}
    </div>
    <ul class="dropdown-menu flex-wrap" v-show="activation">
      <li
        class="option"
        :class="{ active: ordering.value === value.ordering.value }"
        :key="ordering.name"
        v-for="ordering in options.ordering"
        @click="select('ordering', ordering)"
      >
        {{ ordering.name }}
      </li>
      <li class="divider"></li>
      <li
        class="option"
        :class="{ active: created__gte.value === value.created__gte.value }"
        :key="created__gte.name"
        v-for="created__gte in options.created__gte"
        @click="select('created__gte', created__gte)"
      >
        {{ created__gte.name }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ["options", "value", "bodyClass"],
  data() {
    return {
      activation: false
    };
  },
  watch: {
    activation() {
      if (!this.activation) {
        return;
      }

      this.$el.focus();
    }
  },
  methods: {
    toggle() {
      this.activation = !this.activation;
    },
    activate() {
      this.activation = true;
    },
    deactivate() {
      this.activation = false;
    },
    select(key, option) {
      this.value[key] = option;
      this.$emit("input", this.value);
      this.activation = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.dropdown {
  min-width: 100px;
}

.dropdown:focus {
  outline-width: 0;
}

.dropdown-toggle {
  cursor: pointer;
  &::after {
    position: absolute;
    right: 0;
  }
}

.dropdown-menu {
  display: flex;
  flex-direction: column;
  padding: 10px;
}

.option {
  cursor: pointer;
  margin: 4px;
  padding: 4px 10px;
  border-radius: 12px;
  &.active {
    background-color: #b10101;
    color: #fff;
  }
  &:hover {
    background-color: #ededed;
  }
}
.divider {
  margin: 5px;
  border: 1px solid rgba(0, 0, 0, 0.1);
}
</style>
